import { Injectable, signal } from '@angular/core';
import { ForecastVersionResponse } from '@api-response-types/forecast-version.response';

@Injectable({ providedIn: 'root' })
export class ForecastProgressSignalService {
  private readonly _updates = signal<Map<string, ForecastVersionResponse>>(
    new Map(),
  );

  readonly updates = this._updates.asReadonly();

  update(version: ForecastVersionResponse): void {
    this._updates.update((map) => {
      const next = new Map(map);
      next.set(version.configurationId, version);
      return next;
    });
  }
}
